import CapacityGasDTO from 'features/contracts/dtos/CapacityGasDTO';
import NumberFormatter from 'features/shared/components/formatters/NumberFormatter';
import React from 'react';
import CapacityTypeLabel from './CapacityTypeLabel';
import CapacityGasSliding from './CapacityGasSliding';
import styles from './reservedCapacity.module.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  capacity: CapacityGasDTO;
}

const ReservedCapacityGas = ({ capacity }: Props) => {
  //translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // sub-renders
  const renderNumber = (amount: number) => {
    if (amount !== undefined && amount !== null) {
      return (
        <>
          <NumberFormatter amount={amount} />
          <span className="d-sm-none small"> m<sup>3</sup></span>
        </>
      );  
    } else {
      return <>-</>
    }
  };

  const renderSlidingCapacities = () => { 
    if (capacity.slidingReservedCapacity?.length) {
      return capacity.slidingReservedCapacity.map((item, index) =>
        <CapacityGasSliding capacity={item} key={index} />
      );
    } else {
      return <>-</>
    }
  }

  // render
  return (
    <>
      <div className="row no-gutters align-items-center">
        <div className={`col-sm-auto mb-1 mb-sm-0 ${styles.periodCol}`}>
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.timePeriod")}
            </div>
            <div>
              {capacity.month}/{capacity.year}
            </div>
          </div>
        </div>
        <div className="col-sm text-center mb-1 mb-sm-0">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.maxReservedCapacity")}
            </div>
            <div>
              {renderNumber(capacity.maxReservedCapacity!)}
            </div>
          </div>
        </div>
        <div className="col-sm text-center mb-1 mb-sm-0">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.dailyReservedCapacity")}
            </div>
            <div>
              {renderNumber(capacity.dailyReservedCapacity!)}
            </div>
          </div>
        </div>
        <div className="col-sm text-center mb-1 mb-sm-0">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.monthlyReservedCapacity")}
            </div>
            <div>
              {renderNumber(capacity.monthlyReservedCapacity!)}
            </div>
          </div>
        </div>
        <div className="col-sm text-center mb-1 mb-sm-0">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.slidingCapacity")}
            </div>
            <div>
              {renderSlidingCapacities()}
            </div>
          </div>
        </div>
        <div className="col-sm text-center mb-1 mb-sm-0 d-none d-lg-block">
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.dailyMax")}
            </div>
            <div>
              {renderNumber(capacity.dailyMax!)}
            </div>
          </div>
        </div>
        <div className={`col-sm-auto mb-1 mb-sm-0 text-right ${styles.typeCol}`}>
          <div className="d-flex d-sm-block justify-content-between">
            <div className="d-sm-none text-muted pr-2">
              {tLabels("reservedCapacityGas.state")}
            </div>
            <div>
              <CapacityTypeLabel type={capacity.type!} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReservedCapacityGas;